import React from 'react';
// import PropTypes from 'prop-types';
import { useQuery } from 'relay-hooks';
import graphql from 'babel-plugin-relay/macro';
import { useParams } from 'react-router-dom';

import Container from 'react-bootstrap/Container';

import ReversePedigreeTree from '../../dogs/ReversePedigreeTree';

// import DebugDump from '../components/DebugDump';

const generationsToShow = 3;
const treeWidth = 1500;
const treeHeight = 10000;

export default function ReversePedigree() {
  const { id } = useParams();

  const { props: queryResult, error: queryError } = useQuery(
    graphql`
      query ReversePedigree_Query($id: Id!, $depth: Int!) {
        dog(id: $id) {
          ...ReversePedigreeTree_dog @arguments(depth: $depth)
        }
      }
    `,
    {
      id,
      depth: generationsToShow,
    },
  );

  const { dog } = queryResult ?? {};

  return (
    <Container fluid={false}>
      {queryError ? (
        <>
          <div>Error: {queryError.message}</div>
          <div>Source: {JSON.stringify(queryError.source)}</div>
        </>
      ) : !queryResult ? (
        <div>Loading...</div>
      ) : (
        <ReversePedigreeTree
          width={treeWidth}
          height={treeHeight}
          dog={dog}
          generations={generationsToShow}
        />
      )}
    </Container>
  );
}
